module.exports = __webpack_public_path__ + "static/media/slide_grow_bar_chart.eb102694.png";